import { FilterOption } from "~/types/filters.types";
import { FilterActions } from "~/types/actions.enum";

// ✅ Initial states
export const initialState: TFiltersState = {
    companies: [],
    industries: [],

    companyFilters: [],
    industryFilters: [],
    yearFilters: [],

    isLoadingYearFilters: false,
    isLoadingIndustryFilters: false,
    isLoadingCompanyFilters: false
};

// State type defns
export type TFiltersState = {
    companies: FilterOption[];
    industries: FilterOption[];

    companyFilters: FilterOption[];
    industryFilters: FilterOption[];
    yearFilters: FilterOption[];

    isLoadingYearFilters: boolean;
    isLoadingIndustryFilters: boolean;
    isLoadingCompanyFilters: boolean;
};

// Action type defn
export type TFiltersAction =
    | {
          type: FilterActions.SET_COMPANIES_DATA;
          payload: FilterOption[];
      }
    | {
          type: FilterActions.SET_INDUSTRIES_DATA;
          payload: FilterOption[];
      }
    | {
          type: FilterActions.SET_YEAR_FILTERS;
          payload: FilterOption[];
      }
    | {
          type: FilterActions.SET_INDUSTRY_FILTERS;
          payload: FilterOption[];
      }
    | {
          type: FilterActions.SET_COMPANY_FILTERS;
          payload: FilterOption[];
      }
    | {
          type: FilterActions.SET_IS_LOADING_YEARS;
          payload: boolean;
      }
    | {
          type: FilterActions.SET_IS_LOADING_INDUSTRIES;
          payload: boolean;
      }
    | {
          type: FilterActions.SET_IS_LOADING_COMPANIES;
          payload: boolean;
      };

// Store type
export type TFiltersMethods = "dispatch" | "getCompanyById" | "getIndustryById";

export type TFiltersStore = TFiltersState & {
    /**
     * Sets the Filters state using a reducer pattern.
     * @param {TFiltersAction} action - `TFiltersAction` action to apply.
     * @example
     * ```
     * const dispatch = useFiltersStore((state) => state.dispatch)
     * dispatch({ type: FilterActions.SET_YEAR_FILTERS, payload: yearFilters })
     * ```
     */
    dispatch: (action: TFiltersAction) => void;

    getCompanyById: (id: number) => FilterOption | undefined;

    getIndustryById: (id: number) => FilterOption | undefined;
};
